import { compact, isEmpty, isNil, split, toLower, trim } from 'lodash-es';

/**
 * Extracts the primary entry from an entries with multiple values.
 * If it cant be determined what the primary entry is, the first entry
 * in the list will be picked.
 *
 * entry example -
 * [ { displayName: 'Athlete Name_1', metadata: { primary: false } },
 * { displayName: 'Athlete Name_2', metadata: { primary: true } } ]
 *
 * @param {Object} entries - a list of entries with metadata that include a boolean which indicates
 *                        whether an entry is primary or not.
 * @returns
 */
const getPrimaryEntry = (entries) => {
  if (isNil(entries)) {
    return null;
  }
  const primary = entries.find((entry) => {
    const { metadata } = entry;
    return metadata ? metadata.primary : false;
  });
  return isEmpty(primary) ? entries[0] : primary;
};

export const processContactsForUI = (contacts) => {
  const processedContacts = contacts.map((c, index) => {
    const { names, emailAddresses, photos } = c;

    const displayContact = {
      key: index,
      isOnStrava: false
    };
    // email address (required)
    if (isNil(getPrimaryEntry(emailAddresses))) {
      return null;
    }
    displayContact.email = getPrimaryEntry(emailAddresses).value;

    // display name (optional)
    if (isEmpty(names)) {
      displayContact.name = '';
    } else {
      displayContact.name = getPrimaryEntry(names).displayName;
    }
    // avatar picture (optional)
    if (isEmpty(photos)) {
      displayContact.picture = ''; // @strava/ui/Avatar requires blank string (vs null)
    } else {
      displayContact.picture = getPrimaryEntry(photos).url;
    }

    return displayContact;
  });
  return compact(processedContacts);
};

export const extractEmailsFromString = (emails) => {
  return compact(split(toLower(emails), ',').map((email) => trim(email)));
};

export default { processContactsForUI, extractEmailsFromString };
